import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { FaArrowLeft, FaChevronLeft, FaChevronRight, FaPlay, FaTimes } from 'react-icons/fa';
import styles from './pagina_brunovitaltattoo.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { INSTAGRAM_URL, MAPS_URL, WHATSAPP_DEFAULT, useBrunoBackground } from './dados_brunovitaltattoo.ts';

import Vid1 from './src/galeria/WhatsApp Video 2026-11-01 at 16.15.01.mp4';
import Vid2 from './src/galeria/WhatsApp Video 2026-11-01 at 16.15.28.mp4';
import Vid3 from './src/galeria/WhatsApp Video 2026-11-01 at 16.15.36.mp4';
import Vid4 from './src/galeria/WhatsApp Video 2026-11-01 at 16.15.43.mp4';
import Img1 from './src/galeria/1.png';
import Img2 from './src/galeria/2.png';
import Img3 from './src/galeria/3.png';
import Img4 from './src/galeria/4.png';
import Img5 from './src/galeria/5.png';
import Img6 from './src/galeria/6.png';
import Img7 from './src/galeria/7.png';
import Img8 from './src/galeria/8.png';
import Img9 from './src/galeria/9.png';
import Img10 from './src/galeria/10.png';
import Img11 from './src/galeria/11.png';
import Img12 from './src/galeria/12.png';
import Img13 from './src/galeria/13.png';
import Img14 from './src/galeria/14.png';

type ItemGaleria = {
    tipo: 'video' | 'imagem';
    src: string;
};

const DESTAQUES: ItemGaleria[] = [
    { tipo: 'video', src: Vid1 },
    { tipo: 'video', src: Vid2 },
    { tipo: 'video', src: Vid3 },
    { tipo: 'video', src: Vid4 },
];

const FOTOS: ItemGaleria[] = [
    { tipo: 'imagem', src: Img1 },
    { tipo: 'imagem', src: Img2 },
    { tipo: 'imagem', src: Img3 },
    { tipo: 'imagem', src: Img4 },
    { tipo: 'imagem', src: Img5 },
    { tipo: 'imagem', src: Img6 },
    { tipo: 'imagem', src: Img7 },
    { tipo: 'imagem', src: Img8 },
    { tipo: 'imagem', src: Img9 },
    { tipo: 'imagem', src: Img10 },
    { tipo: 'imagem', src: Img11 },
    { tipo: 'imagem', src: Img12 },
    { tipo: 'imagem', src: Img13 },
    { tipo: 'imagem', src: Img14 },
];

const ITENS = [...DESTAQUES, ...FOTOS];

const Tattoo_brunovitaltattoo: React.FC = () => {
    useBrunoBackground();
    const [aberto, setAberto] = useState(false);
    const [indice, setIndice] = useState(0);
    const toqueX = useRef(0);
    const itemAtual = ITENS[indice];

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        document.body.style.overflow = aberto ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [aberto]);

    const abrir = (i: number) => {
        setIndice(i);
        setAberto(true);
    };

    const anterior = () => setIndice((atual) => (atual === 0 ? ITENS.length - 1 : atual - 1));
    const proxima = () => setIndice((atual) => (atual === ITENS.length - 1 ? 0 : atual + 1));

    useEffect(() => {
        if (!aberto) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setAberto(false);
            if (e.key === 'ArrowLeft') anterior();
            if (e.key === 'ArrowRight') proxima();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [aberto]);

    const renderThumb = (item: ItemGaleria, i: number, destaque = false) => (
        <motion.button
            key={item.src}
            type="button"
            className={`${styles.thumb} ${destaque ? styles.thumbDestaque : ''}`}
            onClick={() => abrir(i)}
            aria-label={item.tipo === 'video' ? `Reproduzir destaque ${i + 1}` : `Abrir tatuagem ${i - DESTAQUES.length + 1}`}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.45, delay: (i % 6) * 0.04, ease: [0.22, 1, 0.36, 1] }}
        >
            {item.tipo === 'video' ? (
                <video src={`${item.src}#t=0.1`} muted loop playsInline autoPlay preload="metadata" />
            ) : (
                <img src={item.src} alt={`Trabalho de Bruno Vital ${i - DESTAQUES.length + 1}`} />
            )}
            {item.tipo === 'video' ? (
                <span className={styles.playBadge} aria-hidden>
                    <FaPlay />
                </span>
            ) : null}
        </motion.button>
    );

    return (
        <div className={styles.pagina} lang="pt-BR">
            <div className={styles.header}>
                <Link to="/brunovitaltattoo" className={styles.backButton} aria-label="Voltar">
                    <FaArrowLeft />
                </Link>
                <h1 className={styles.headerTitle}>Tattoo</h1>
            </div>

            <div className={styles.page}>
                <p className={styles.eyebrow}>Galeria</p>
                <h2 className={styles.name}>Trabalhos</h2>

                <h3 className={styles.groupTitle}>Destaques</h3>
                <div className={styles.galleryDestaques}>
                    {DESTAQUES.map((item, i) => renderThumb(item, i, true))}
                </div>

                <h3 className={styles.groupTitle}>Fotos</h3>
                <div className={styles.gallery}>
                    {FOTOS.map((item, i) => renderThumb(item, i + DESTAQUES.length))}
                </div>
            </div>

            <AnimatePresence>
                {aberto ? (
                    <motion.div
                        className={styles.lightbox}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setAberto(false)}
                        onTouchStart={(e) => {
                            toqueX.current = e.changedTouches[0].clientX;
                        }}
                        onTouchEnd={(e) => {
                            const delta = e.changedTouches[0].clientX - toqueX.current;
                            if (delta > 50) anterior();
                            if (delta < -50) proxima();
                        }}
                    >
                        <button
                            type="button"
                            className={`${styles.lightboxBtn} ${styles.closeBtn}`}
                            onClick={() => setAberto(false)}
                            aria-label="Fechar"
                        >
                            <FaTimes />
                        </button>
                        <button
                            type="button"
                            className={`${styles.lightboxBtn} ${styles.prevBtn}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                anterior();
                            }}
                            aria-label="Anterior"
                        >
                            <FaChevronLeft />
                        </button>
                        {itemAtual.tipo === 'video' ? (
                            <motion.video
                                key={itemAtual.src}
                                className={styles.lightboxVideo}
                                src={itemAtual.src}
                                controls
                                autoPlay
                                playsInline
                                initial={{ opacity: 0, scale: 0.97 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.28 }}
                                onClick={(e) => e.stopPropagation()}
                                onTouchStart={(e) => e.stopPropagation()}
                                onTouchEnd={(e) => e.stopPropagation()}
                            />
                        ) : (
                            <motion.img
                                key={itemAtual.src}
                                className={styles.lightboxImg}
                                src={itemAtual.src}
                                alt={`Trabalho de Bruno Vital ${indice - DESTAQUES.length + 1}`}
                                initial={{ opacity: 0, scale: 0.97 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.28 }}
                                onClick={(e) => e.stopPropagation()}
                            />
                        )}
                        <button
                            type="button"
                            className={`${styles.lightboxBtn} ${styles.nextBtn}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                proxima();
                            }}
                            aria-label="Próxima"
                        >
                            <FaChevronRight />
                        </button>
                        <span className={styles.counter}>
                            {indice + 1} / {ITENS.length}
                        </span>
                    </motion.div>
                ) : null}
            </AnimatePresence>

            <div className={styles.footer}>
                <div className={styles.divSocials}>
                    <a href={WHATSAPP_DEFAULT} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <WhatsappIcon height="26" color="#c4a574" />
                        </div>
                        <span>WhatsApp</span>
                    </a>
                    <a href={MAPS_URL} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <MapsIcon height="26" color="#c4a574" />
                        </div>
                        <span>Localização</span>
                    </a>
                    <a href={INSTAGRAM_URL} className={styles.socials} target="_blank" rel="noopener noreferrer">
                        <div className={styles.iconPlaceholder}>
                            <InstagramIcon height="22" color="#c4a574" />
                        </div>
                        <span>Instagram</span>
                    </a>
                </div>
                <div className={styles.signature}>
                    Desenvolvido por{' '}
                    <a href="https://www.linksvibe.com.br" target="_blank" rel="noreferrer">
                        Links Vibe
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Tattoo_brunovitaltattoo;
